// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"21f21f92","132":"0e504640","873":"cc47bcd1","918":"74d10cff","950":"005c4ac8"}[chunkId] + ".chunk.js";
};